export const SET_EPIC_CREDS = "SET_EPIC_CREDS";

export const setEpicDetails = (payload) => {
   return {
      type: SET_EPIC_CREDS,
      payload: payload,
   };
};
